export const costs = [
  'Noches en vela buscando cómo traducir conceptos de energías renovables complejos a un lenguaje que tus alumnos puedan entender.',
  'Clases improvisadas porque no encontraste un material claro y listo para usar a tiempo.',
  'Alumnos desconectados que sienten que las energías renovables no tienen nada que ver con ellos ni con su carrera.',
  'Silencios incómodos cuando un alumno pregunta cómo se dimensiona un panel solar o qué tipo de batería usar y no tienes una respuesta clara a mano.',
  'Fines de semana perdidos armando planificaciones, proyectos técnicos y evaluaciones desde cero una y otra vez.',
  'Incertidumbre sobre cómo enseñar sistemas híbridos, biogás o aprovechamientos geotérmicos sin los recursos adecuados.',
];
